import {
  SALARY_DETAIL_GET,
  SALARY_DETAIL_ERROR,
  SALARY_DETAIL_RESET,
} from '../../actions/types';

const initialState = null;

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SALARY_DETAIL_GET:
      return action.payload;
    case SALARY_DETAIL_ERROR:
      return state;
    case SALARY_DETAIL_RESET:
      return initialState;
    default:
      return state;
  }
}
